import { motion } from "framer-motion";
import { MessageCircle, Instagram, Globe, MapPin, ArrowUpRight } from "lucide-react";
import { CONTACT, waLink } from "../data/site";

const LINKS = [
  { id: "whatsapp", label: "WhatsApp", sub: CONTACT.phone, icon: MessageCircle, href: waLink("Olá, Alfa Gráfica Digital! Gostaria de fazer um orçamento.") },
  { id: "instagram", label: "Instagram", sub: `@${CONTACT.instagram}`, icon: Instagram, href: `https://instagram.com/${CONTACT.instagram}` },
  { id: "site", label: "Site", sub: CONTACT.site, icon: Globe, href: `https://${CONTACT.site}` },
  { id: "endereco", label: "Endereço", sub: CONTACT.address, icon: MapPin, href: `https://maps.google.com/?q=${encodeURIComponent(CONTACT.address)}` },
];

export const Links = () => (
  <section data-testid="contact-links" className="px-5 sm:px-10 py-16 lg:py-24 grid lg:grid-cols-12 gap-10">
    <div className="lg:col-span-4">
      <p className="font-mono text-xs uppercase tracking-[0.3em] text-ink-soft">( Links )</p>
      <h2 className="mt-4 font-display text-4xl sm:text-5xl leading-none">Fale com a <em className="text-alga">gente</em>.</h2>
    </div>
    <ul className="lg:col-span-8 min-w-0 border-t border-ink/15">
      {LINKS.map(({ id, label, sub, icon: Icon, href }, i) => (
        <motion.li key={id} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }} transition={{ duration: 0.7, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}>
          <a href={href} target="_blank" rel="noopener noreferrer" data-testid={`link-${id}`} className="link-row group relative flex items-center gap-5 border-b border-ink/15 py-6 sm:py-7 px-2 overflow-hidden">
            <span className="link-fill absolute inset-0 bg-ink origin-bottom scale-y-0 transition-transform duration-500 ease-[cubic-bezier(.22,1,.36,1)] group-hover:scale-y-100" />
            <span className="relative font-mono text-xs text-ink-soft group-hover:text-paper/70 transition-colors">0{i + 1}</span>
            <Icon className="relative h-5 w-5 shrink-0 text-alga group-hover:text-lime transition-colors" strokeWidth={1.5} />
            <span className="relative flex-1 min-w-0">
              <span className="block font-display text-xl sm:text-2xl leading-tight group-hover:text-paper transition-colors">{label}</span>
              <span className="block text-sm text-ink-soft group-hover:text-paper/80 transition-colors">{sub}</span>
            </span>
            <ArrowUpRight className="relative h-6 w-6 shrink-0 transition-[transform,color] duration-500 group-hover:rotate-45 group-hover:text-paper" strokeWidth={1.25} />
          </a>
        </motion.li>
      ))}
    </ul>
  </section>
);
